import { Card, Notice, RuledPage } from '@kollez/design-system';
import { Link } from 'react-router-dom';

/**
 * Forgot-password placeholder — 5 states in the static kit; MVP ships the first (request)
 * with a stub that reassures the user email is queued. Full 5-view flow lands with the
 * MSG91/Azure Comm wiring in Phase 2.
 */
export function ForgotPasswordPage() {
  return (
    <RuledPage>
      <section className="max-w-page-narrow mx-auto px-6 py-16">
        <p className="eyebrow">Password reset</p>
        <h1 className="font-serif text-4xl mb-6">Let's get you back in.</h1>
        <Card padding="lg" className="max-w-md">
          <Notice tone="info" className="mb-4">
            Enter your email — we'll send a reset link that expires in one hour. Full flow ships
            when SMS + email transport lands.
          </Notice>
          <label className="grid gap-1.5">
            <span className="label text-sm">Email</span>
            <input className="input" type="email" />
          </label>
          <div className="mt-4 flex justify-between">
            <Link to="/login" className="link text-sm">Back to sign in</Link>
            <button className="btn btn-primary btn-sm" type="button">Send reset link</button>
          </div>
        </Card>
      </section>
    </RuledPage>
  );
}
